var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 3.552 0.448 4 1 4H15C15.552 4 16 3.552 16 3C16 2.448 15.552 2 15 2H1C0.448 2 0 2.448 0 3ZM1 9C0.448 9 0 8.552 0 8C0 7.448 0.448 7 1 7H15C15.552 7 16 7.448 16 8C16 8.552 15.552 9 15 9H1ZM1 14C0.448 14 0 13.552 0 13C0 12.448 0.448 12 1 12H15C15.552 12 16 12.448 16 13C16 13.552 15.552 14 15 14H1Z",
    fill: "inherit"
  })));
};
export default SvgBurger;